import { render, staticRenderFns } from "./RosterGroupEdit.vue?vue&type=template&id=0ae12ab3&scoped=true&"
import script from "./RosterGroupEdit.vue?vue&type=script&lang=js&"
export * from "./RosterGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./RosterGroupEdit.vue?vue&type=style&index=0&id=0ae12ab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae12ab3",
  null
  
)

export default component.exports